import API from "../../../../../global/api";


export const requestAddPermissions = () => {
  return {
    type: "REQUEST_ADD_PERMISSIONS",
  };
};
export const successAddPermissions = (data) => {
  return {
    type: "SUCCESS_ADD_PERMISSIONS",
    payload: data,
  };
};
export const errorAddPermissions = () => {
  return {
    type: "ERROR_ADD_PERMISSIONS",
  };
};
export const addPermissions = (data, handleVisible, handleDangerVisible) => {
  return (dispatch) => {
    dispatch(requestAddPermissions());
    API.post(`/permission/add-assigned-permission`, data).then((res) => {
      handleVisible();
      let getData = res.data;
      dispatch(successAddPermissions(getData));
    }).catch((error) => {
      handleDangerVisible();
      dispatch(errorAddPermissions());
    })
  };
};


export const requestGetPermissions = () => {
  return {
    type: "REQUEST_GET_PERMISSIONS",
  };
};
export const successGetPermissions = (data) => {
  return {
    type: "SUCCESS_GET_PERMISSIONS",
    payload: data,
  };
};
export const errorGetPermissions = () => {
  return {
    type: "ERROR_GET_PERMISSIONS",
  };
};
export const getPermissions = () => {
  return (dispatch) => {
    dispatch(requestGetPermissions());
    API.get(`/permission/get-permissions`).then((res) => {
      let getData = res.data;
      dispatch(successGetPermissions(getData));
    }).catch((error) => {
      dispatch(errorGetPermissions());
    })
  };
};